import { EventEmitter, Injectable, Output, Directive } from "@angular/core";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {Registration} from "../../models/registration";

@Directive()
@Injectable()
export class ResultService {

  public serviceId: string;
  public registration: Registration;
  public documentResultList: any[];
  public documentResult: any;
  public addNew: boolean;
  public showDeterminantBuilder: boolean;

  @Output() public editData: EventEmitter<any> = new EventEmitter();
  @Output() public change: EventEmitter<any> = new EventEmitter();
  @Output() public update: EventEmitter<any> = new EventEmitter();

  public initEdit() {
    this.editData.emit({
      serviceId: this.serviceId,
      registration: this.registration,
      documentResult: this.documentResult,
      addNew: this.addNew,
      showDeterminantBuilder: this.showDeterminantBuilder,
    });
  }

  public updateData() {
    this.update.emit({
      update: true,
    });
  }

}
